<div class="servicio">
  <div class="intro">
    <div class="userData">
      <div class="welcome">
        <!-- Header con título -->
        <div class="info">
          <div class="titulo-servicios">
            <svg width="24" height="24" viewBox="0 0 22 19" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M6.75 2.75C6.75 1.96244 7.28866 1.5 7.75 1.5C8.21134 1.5 8.75 1.96244 8.75 2.75C8.75 3.53756 8.21134 4 7.75 4C7.28866 4 6.75 3.53756 6.75 2.75ZM7.75 0C6.27835 0 5.25 1.32842 5.25 2.75C5.25 4.17158 6.27835 5.5 7.75 5.5C9.22165 5.5 10.25 4.17158 10.25 2.75C10.25 1.32842 9.22165 0 7.75 0ZM2.5 5C2.03866 5 1.5 5.46244 1.5 6.25C1.5 7.03756 2.03866 7.5 2.5 7.5C2.96134 7.5 3.5 7.03756 3.5 6.25C3.5 5.46244 2.96134 5 2.5 5ZM0 6.25C0 4.82842 1.02835 3.5 2.5 3.5C3.97165 3.5 5 4.82842 5 6.25C5 7.67158 3.97165 9 2.5 9C1.02835 9 0 7.67158 0 6.25ZM11 9C7.96243 9 5.5 11.4624 5.5 14.5C5.5 15.2619 5.88204 15.8601 6.53553 16.2979C7.20638 16.7474 8.13609 17 9.07824 17H12.9218C13.8639 17 14.7936 16.7474 15.4645 16.2979C16.118 15.8601 16.5 15.2619 16.5 14.5C16.5 11.4624 14.0376 9 11 9ZM4 14.5C4 10.634 7.13401 7.5 11 7.5C14.866 7.5 18 10.634 18 14.5C18 15.8608 17.2793 16.8876 16.2994 17.5441C15.3368 18.189 14.1024 18.5 12.9218 18.5H9.07824C7.89764 18.5 6.66323 18.189 5.70065 17.5441C4.72071 16.8876 4 15.8608 4 14.5ZM14.25 1.5C13.7887 1.5 13.25 1.96244 13.25 2.75C13.25 3.53756 13.7887 4 14.25 4C14.7113 4 15.25 3.53756 15.25 2.75C15.25 1.96244 14.7113 1.5 14.25 1.5ZM11.75 2.75C11.75 1.32842 12.7783 0 14.25 0C15.7217 0 16.75 1.32842 16.75 2.75C16.75 4.17158 15.7217 5.5 14.25 5.5C12.7783 5.5 11.75 4.17158 11.75 2.75ZM18.5 6.25C18.5 5.46244 19.0387 5 19.5 5C19.9613 5 20.5 5.46244 20.5 6.25C20.5 7.03756 19.9613 7.5 19.5 7.5C19.0387 7.5 18.5 7.03756 18.5 6.25ZM19.5 3.5C18.0283 3.5 17 4.82842 17 6.25C17 7.67158 18.0283 9 19.5 9C20.9717 9 22 7.67158 22 6.25C22 4.82842 20.9717 3.5 19.5 3.5Z" fill="#208FE4"/>
            </svg>
            <h1>{{ update ? 'Actualizar Mascota' : 'Agregar Mascota' }}</h1>
            <!---->
          </div>
        </div>

         <div *ngIf="imagenPreview" class="imagen-preview-contenedor">
          <div class="titulo-foto">📷</div>
          <div class="imagen-preview">
          <img [src]="imagenPreview" alt="Preview masctoa" />
          </div>
        </div>



        <!-- Botón de fotografía -->
        <button class="photo-button"  (click)="onFileSelected($event)" >
          <span>Agregar fotografía (opcional)</span>
          <input type="file" (change)="onFileSelected($event)" accept="image/*">
          <svg width="18" height="18" viewBox="0 0 18 17" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M6.62387 0C6.05682 0 5.53824 0.319766 5.28361 0.826432L4.69412 1.9994H3.00464C1.62393 1.9994 0.504639 3.11868 0.504639 4.4994V12.5C0.504639 13.8807 1.62393 15 3.00464 15H8.09965C7.93771 14.6832 7.80558 14.3486 7.70697 14H3.00464C2.17621 14 1.50464 13.3284 1.50464 12.5V4.4994C1.50464 3.67097 2.17621 2.9994 3.00464 2.9994H5.00243C5.19145 2.9994 5.36431 2.89281 5.44919 2.72392L6.17712 1.27548C6.262 1.10659 6.43486 1 6.62387 1H10.3881C10.5775 1 10.7506 1.10702 10.8353 1.27643L11.5584 2.72296C11.6431 2.89238 11.8162 2.9994 12.0056 2.9994H14.0046C14.8331 2.9994 15.5046 3.67097 15.5046 4.4994V7.60212C15.8625 7.78548 16.1976 8.0069 16.5046 8.26105V4.4994C16.5046 3.11869 15.3854 1.9994 14.0046 1.9994H12.3147L11.7298 0.829302C11.4757 0.321059 10.9563 0 10.3881 0H6.62387ZM8.49994 4.00003C10.3761 4.00003 11.9505 5.29169 12.3826 7.03426C12.0455 7.07192 11.7176 7.14004 11.4017 7.23581C11.0638 5.94911 9.89269 5.00003 8.49994 5.00003C6.84308 5.00003 5.49994 6.34318 5.49994 8.00003C5.49994 9.39279 6.44903 10.5639 7.73574 10.9018C7.63997 11.2177 7.57185 11.5456 7.5342 11.8827C5.79162 11.4507 4.49994 9.87619 4.49994 8.00003C4.49994 5.79089 6.2908 4.00003 8.49994 4.00003ZM17.4999 12.5C17.4999 14.9853 15.4852 17 12.9999 17C10.5147 17 8.49994 14.9853 8.49994 12.5C8.49994 10.0147 10.5147 8 12.9999 8C15.4852 8 17.4999 10.0147 17.4999 12.5ZM13.4999 10.5C13.4999 10.2239 13.2761 10 12.9999 10C12.7238 10 12.4999 10.2239 12.4999 10.5V12H10.9999C10.7238 12 10.4999 12.2239 10.4999 12.5C10.4999 12.7761 10.7238 13 10.9999 13H12.4999V14.5C12.4999 14.7761 12.7238 15 12.9999 15C13.2761 15 13.4999 14.7761 13.4999 14.5V13H14.9999C15.2761 13 15.4999 12.7761 15.4999 12.5C15.4999 12.2239 15.2761 12 14.9999 12H13.4999V10.5Z" fill="#0E365A"/>
          </svg>
        </button>

        <!-- Campos del formulario -->
        <div class="text-field">
          <div class="content">
            <input type="text" placeholder="Nombre" [(ngModel)]="nombre">
          </div>
        </div>

        <div class="text-field">
          <div class="content">
            <select [(ngModel)]="especie">
              <option value="">Especie</option>
              <option value="perro">Perro</option>
              <option value="gato">Gato</option>
              <option value="otro">Otro</option>
            </select>
            <svg width="24" height="24" viewBox="0 0 16 9" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M0.21967 0.46967C0.512563 0.176777 0.987437 0.176777 1.28033 0.46967L8 7.18934L14.7197 0.46967C15.0126 0.176777 15.4874 0.176777 15.7803 0.46967C16.0732 0.762563 16.0732 1.23744 15.7803 1.53033L8.53033 8.78033C8.23744 9.07322 7.76256 9.07322 7.46967 8.78033L0.21967 1.53033C-0.0732233 1.23744 -0.0732233 0.762563 0.21967 0.46967Z" fill="#103A5A"/>
            </svg>
          </div>
        </div>

        <div class="text-field">
          <div class="content">
            <select [(ngModel)]="genero">
              <option value="">Género</option>
              <option value="macho">Macho</option>
              <option value="hembra">Hembra</option>
            </select>
            <svg width="24" height="24" viewBox="0 0 16 9" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M0.21967 0.46967C0.512563 0.176777 0.987437 0.176777 1.28033 0.46967L8 7.18934L14.7197 0.46967C15.0126 0.176777 15.4874 0.176777 15.7803 0.46967C16.0732 0.762563 16.0732 1.23744 15.7803 1.53033L8.53033 8.78033C8.23744 9.07322 7.76256 9.07322 7.46967 8.78033L0.21967 1.53033C-0.0732233 1.23744 -0.0732233 0.762563 0.21967 0.46967Z" fill="#103A5A"/>
            </svg>
          </div>
        </div>

        <div class="text-field">
          <div class="content">
            <input type="text" placeholder="Raza" [(ngModel)]="raza">
          </div>
        </div>

        <div class="text-field">
          <div class="content">
            <select [(ngModel)]="edad">
               <option value="">Edad</option>
               <option *ngFor="let num of numbers" [ngValue]="num">{{ num }}</option>
              <!--<option value="">Edad</option>
              <option value="cachorro">Cachorro (0-1 año)</option>
              <option value="joven">Joven (1-3 años)</option>
              <option value="adulto">Adulto (3-7 años)</option>
              <option value="senior">Senior (7+ años)</option>-->
            </select>
            <svg width="24" height="24" viewBox="0 0 16 9" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M0.21967 0.46967C0.512563 0.176777 0.987437 0.176777 1.28033 0.46967L8 7.18934L14.7197 0.46967C15.0126 0.176777 15.4874 0.176777 15.7803 0.46967C16.0732 0.762563 16.0732 1.23744 15.7803 1.53033L8.53033 8.78033C8.23744 9.07322 7.76256 9.07322 7.46967 8.78033L0.21967 1.53033C-0.0732233 1.23744 -0.0732233 0.762563 0.21967 0.46967Z" fill="#103A5A"/>
            </svg>
          </div>
        </div>

        <div class="text-field">
          <div class="content">
            <input type="text" placeholder="Peso (kg)" [(ngModel)]="peso">
          </div>
        </div>

        <!--
        <div class="text-field">
          <div class="content">
            <input type="text" placeholder="Identificador (opcional)" [(ngModel)]="identificador">
          </div>
        </div>
      -->

        <!-- Botón registrar -->
        <div class="button-row">
          <button class="register-button" (click)="registrarMascota()">
            {{ update ? 'Actualizar Mascota' : 'Agregar Mascota' }}
          </button>


        </div>
      </div>
    </div>
  </div>
</div>
